var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSbp = function SvgSbp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.487 17.991-4.692 2.707-4.357 7.552L20.203 17.99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.893 10.259-4.691 2.706-4.358 7.552L33.609 10.26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.202 7.552 15.844 0v35.991l4.358-7.552z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.844 0 4.358 7.552 4.691 2.707h8.716zM15.844 15.473V35.99l4.358-7.551v-5.414zM24.893 25.733l-4.691 2.707-4.358 7.552 17.765-10.26zM2.438 7.742V28.25l4.357-7.543v-5.422z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.845 15.474.009.01L2.438 7.741l4.357 7.543 18.1 10.448h8.715z"
  })));
};
export default SvgSbp;